import React, { FC } from 'react';

import useBestImageForBackgroundColor from '~/core/hooks/useBestImageForBackgroundColor';

import { GameCenterTeam } from '../../../../../types';

import { TeamLogo } from './styles';

type Props = {
    team: GameCenterTeam;
    isSmall?: boolean;
    isFaded?: boolean;
    backgroundColor: string;
};

export const GoalTeam: FC<Props> = ({ team, isSmall = false, isFaded = false, backgroundColor }) => {
    const [teamLogoUrl] = useBestImageForBackgroundColor(team.logo, team.darkLogo, backgroundColor);

    return (
        teamLogoUrl && (
            <TeamLogo
                displayName={false}
                $isFaded={isFaded}
                $isSmall={isSmall}
                logoUrlOverride={teamLogoUrl}
                team={{ triCode: team.abbrev }}
            />
        )
    );
};
